import { useContext, useEffect, useState } from "react";
import { Divider, Link, Select, TextField } from "@shopify/polaris";
import {
    BundleTypes,
    WIDGET_POSITIONS_OPT,
    WidgetPositions,
    WidgetPositionsAddons,
    WidgetPositionsTypes,
    WidgetPositionsVolume,
} from "../constants";
import styles from "./CommonFields.module.css";
import { Field } from "@shopify/react-form";
import { AppConfigContext } from "../../../context/AppConfigContext";
import AndSeparator from "../../../components/Separators/AndSeparator";

export const getAppBlockDeepLink = ({
    shop,
    bundleType,
    extensionId,
}: {
    shop: string;
    bundleType: string;
    extensionId: string;
}) => {
    const template = "product";

    const blockHandle: Record<string, string> = {
        [BundleTypes.FBT]: "FBTPosition",
        [BundleTypes.VOLUME_DISCOUNT]: "VolumePosition",
        [BundleTypes.PRODUCT_ADDONS]: "ProductAddOn",
        [BundleTypes.STANDARD]: "standardPosition",
        [BundleTypes.BXGY]: "BXGYPosition",
        [BundleTypes.MIX_MATCH]: "MNMPosition",
        [BundleTypes.BUY_N]: "BuyNPosition",
        [BundleTypes.MIX_MATCH_SECTIONAL]: "MNMSPosition",
        [BundleTypes.BUNDLE_BUILDER]: "BundleBuilderPosition",
        [BundleTypes.BB_PLACEHOLDER]: "PlaceholderPosition",
    };
    const target = bundleType === BundleTypes.FBT ? "newAppsSection" : "mainSection";

    return `https://${shop}.myshopify.com/admin/themes/current/editor?template=${template}&addAppBlockId=${extensionId}/${blockHandle[bundleType]}&target=${target}`;
};

const WidgetPositionsSelector = ({
    bundle_position,
    bundleType,
    custom_selector,
    dispatchBundleConfig,
    submit,
}: {
    bundle_position: Field<WidgetPositionsTypes>;
    custom_selector: Field<string>;
    dispatchBundleConfig: any;
    submit: (event?: React.FormEvent) => Promise<void>;
    bundleType: string;
}) => {
    const [modifiedOptions, setModifiedOptions] = useState(WidgetPositions);
    const appConfigContext = useContext(AppConfigContext);

    useEffect(() => {
        setModifiedOptions(() => {
            let temp = [...WidgetPositions];

            if (bundleType == BundleTypes.FBT) {
                // do nothing cause, i dont wanna run last else part in fbt
            } else if (bundleType === BundleTypes.VOLUME_DISCOUNT) {
                return WidgetPositionsVolume;
            } else if (bundleType === BundleTypes.PRODUCT_ADDONS) {
                let filteredOptions = WidgetPositionsAddons.filter(
                    (old) => old.value !== (WIDGET_POSITIONS_OPT.FBT_DEFAULT as WidgetPositionsTypes),
                );

                if (!filteredOptions.some((old) => old.value === WIDGET_POSITIONS_OPT.ABOVE_CART)) {
                    filteredOptions = [
                        { label: "Above Add-to-Cart (Default)", value: WIDGET_POSITIONS_OPT.ABOVE_CART },
                        ...filteredOptions,
                    ];
                }

                return filteredOptions;
            } else {
                temp = temp.filter((old) => old.value !== (WIDGET_POSITIONS_OPT.FBT_DEFAULT as WidgetPositionsTypes));
            }
            return temp;
        });
    }, [bundleType]);

    return (
        <>
            <div className={`${styles.formRow} ${styles.row2}`} style={{ marginTop: -10 }}>
                <div style={{ lineHeight: "20px", display: "flex", flexDirection: "column", gap: 10 }}>
                    <div>
                        By default, the widget will appear {modifiedOptions[0].label}. <br /> To change its position,
                        open the
                        <Link
                            url={getAppBlockDeepLink({
                                shop: appConfigContext.shop,
                                extensionId: appConfigContext.extensionId,
                                bundleType,
                            })}
                            external
                        >
                            Shopify Theme Editor
                        </Link>
                        ,and drag the app block to your preferred location.
                    </div>
                    <div>
                        <Link
                            external
                            url={
                                "https://help.keficommerce.com/en/articles/10591914-how-to-position-bundles-on-your-product-page"
                            }
                        >
                            Need help?
                        </Link>
                    </div>
                </div>
            </div>
            <Divider />
        </>
    );
};

export default WidgetPositionsSelector;
